export enum DisplayType {
    Modal = 'modal',
    Inline = 'inline'
}

export interface ModalDisplayTypeOptions {
    type: DisplayType.Modal;
    
  }
  
  export interface InlineDisplayTypeOptions {
    type: DisplayType.Inline;
    selector: string;
    modalAsBackup: boolean;
  }
  
export  type DisplayTypeOptions = 
    | ModalDisplayTypeOptions
    | InlineDisplayTypeOptions;